// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from '../../Types/generated-types'

import gql from 'graphql-tag'
import * as Urql from 'urql'
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>
export type GetCompanyQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']
}>

export type GetCompanyQuery = {
  __typename?: 'Query'
  getCompany: { __typename?: 'Company'; ID: number; name: string; currency: string }
}

export const GetCompanyDocument = gql`
  query GetCompany($id: Int!) {
    getCompany(ID: $id) {
      ID
      name
      currency
    }
  }
`

export function useGetCompanyQuery(
  options: Omit<Urql.UseQueryArgs<GetCompanyQueryVariables>, 'query'>
) {
  return Urql.useQuery<GetCompanyQuery, GetCompanyQueryVariables>({
    query: GetCompanyDocument,
    ...options,
  })
}
